// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n:root {\n  --popupHeaderFooterHeight: calc(70px * 2);\n  --popupVerticalMargin: calc(30px * 2);\n  --popupPreoccupiedHeight: calc(\n    var(--popupHeaderFooterHeight) + var(--popupVerticalMargin)\n  );\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
